import { render, staticRenderFns } from "./ListEvent.vue?vue&type=template&id=63556f66&scoped=true"
import script from "./ListEvent.vue?vue&type=script&lang=js"
export * from "./ListEvent.vue?vue&type=script&lang=js"
import style0 from "./ListEvent.vue?vue&type=style&index=0&id=63556f66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63556f66",
  null
  
)

export default component.exports